import React from 'react';
export function SocialProofBar() {
  return <div className="w-full bg-[#F0F4FF] py-6 border-y border-blue-100" data-id="element-159">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-160">
        <div className="grid grid-cols-2 md:flex md:flex-row items-center justify-center gap-4 md:gap-0 divide-transparent md:divide-gold/30 md:divide-x-2" data-id="element-161">
          <div className="flex items-center justify-center px-4 text-center" data-id="element-162">
            <span className="font-inter font-medium text-navy text-sm sm:text-base" data-id="element-163">
              ⭐⭐⭐⭐⭐ 4.9/5 estrellas
            </span>
          </div>

          <div className="flex items-center justify-center px-4 text-center" data-id="element-164">
            <span className="font-inter font-medium text-navy text-sm sm:text-base" data-id="element-165">
              👩‍🏫 +500 Docentes ya lo usan
            </span>
          </div>

          <div className="flex items-center justify-center px-4 text-center" data-id="element-166">
            <span className="font-inter font-medium text-navy text-sm sm:text-base" data-id="element-167">
              🇦🇷 Hecho para Argentina
            </span>
          </div>

          <div className="flex items-center justify-center px-4 text-center" data-id="element-168">
            <span className="font-inter font-medium text-navy text-sm sm:text-base" data-id="element-169">
              ⏱️ Ahorrá 5-10hs por semana
            </span>
          </div>
        </div>
      </div>
    </div>;
}